module.exports = __webpack_public_path__ + "assets/cancel.585b265fd0d75a6aeb5fef08a48e5970.svg";


//////////////////
// WEBPACK FOOTER
// ./img/cancel.svg
// module id = 933
// module chunks = 0